import { Link } from 'react-router-dom';

const articles = [
  {
    id: 'article-1',
    title: 'How to Find the Best Pandabuy Spreadsheet for Sneakers in 2026',
    excerpt: 'A step-by-step guide to navigating pandabuy spreadsheet links and finding quality sneaker deals that actually deliver.',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20product%20photography%20of%20a%20single%20pair%20of%20premium%20lifestyle%20sneakers%20in%20warm%20cream%20and%20sandy%20tones%20placed%20on%20a%20clean%20minimalist%20surface%20with%20soft%20natural%20lighting%2C%20elegant%20composition%20with%20abundant%20negative%20space%2C%20high%20end%20ecommerce%20aesthetic%2C%20detailed%20texture%20visible%20on%20suede%20and%20leather%20panels%2C%20no%20branding&width=600&height=400&seq=seo-card-01-v2&orientation=landscape',
  },
  {
    id: 'article-2',
    title: 'Pandabuy Spreadsheet Categories Explained: Shoes to Accessories',
    excerpt: 'Breaking down all 14 categories in the pandabuy spreadsheet directory so you know exactly where to look for every product type.',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20various%20fashion%20items%20including%20a%20watch%20sunglasses%20and%20a%20small%20bag%20arranged%20in%20neat%20organized%20rows%20on%20a%20cream%20linen%20surface%2C%20soft%20window%20light%2C%20editorial%20catalog%20style%20composition%2C%20warm%20neutral%20earth%20tones%2C%20clean%20professional%20aesthetic%2C%20no%20branding%20visible&width=600&height=400&seq=seo-card-02-v2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: 'Why Daily Updated Pandabuy Spreadsheets Save You Time and Money',
    excerpt: 'Dead links waste hours. Learn why daily updated pandabuy spreadsheet directories give you the edge over forum hunting.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20workspace%20scene%20with%20a%20modern%20laptop%20displaying%20a%20spreadsheet%20interface%20on%20a%20warm%20wooden%20desk%20surface%2C%20soft%20natural%20morning%20light%20streaming%20through%20a%20window%2C%20minimalist%20productive%20atmosphere%2C%20neutral%20cream%20and%20beige%20tones%2C%20calm%20focused%20aesthetic%2C%20no%20screen%20content%20detail%20visible&width=600&height=400&seq=seo-card-03-v2&orientation=landscape',
  },
  {
    id: 'article-4',
    title: 'Top 10 Most Popular Pandabuy Spreadsheet Finds Right Now',
    excerpt: 'The trending products that pandabuy spreadsheet users are loving this month across shoes, hoodies, bags and accessories.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20flat%20lay%20of%20a%20pair%20of%20sneakers%20a%20folded%20hoodie%20and%20a%20canvas%20bag%20arranged%20harmoniously%20on%20a%20cream%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20lifestyle%20composition%2C%20warm%20earthy%20palette%2C%20clean%20modern%20aesthetic%2C%20no%20branding%20visible&width=600&height=400&seq=seo-card-04-v2&orientation=landscape',
  },
  {
    id: 'article-5',
    title: 'Beginner Guide: How to Use a Pandabuy Spreadsheet Step by Step',
    excerpt: 'New to pandabuy spreadsheet shopping? This beginner walkthrough covers everything from choosing categories to checking seller quality.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20pair%20of%20simple%20classic%20sneakers%20next%20to%20a%20neatly%20folded%20hoodie%20on%20a%20pristine%20white%20surface%2C%20soft%20natural%20studio%20lighting%2C%20editorial%20ecommerce%20composition%2C%20warm%20neutral%20tones%2C%20beginner%20friendly%20approachable%20aesthetic%2C%20no%20branding&width=600&height=400&seq=seo-card-05-v2&orientation=landscape',
  },
  {
    id: 'article-6',
    title: 'How We Verify Pandabuy Spreadsheet Links for Quality and Safety',
    excerpt: 'Behind the scenes of our pandabuy spreadsheet curation process — how links are checked for reliability before reaching you.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20desk%20scene%20with%20a%20notebook%20pen%20and%20neatly%20arranged%20accessories%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20lighting%20from%20the%20side%2C%20organized%20and%20methodical%20atmosphere%2C%20calm%20productive%20aesthetic%2C%20neutral%20earth%20tones%2C%20no%20branding%20visible&width=600&height=400&seq=seo-card-06-v2&orientation=landscape',
  },
  {
    id: 'article-7',
    title: 'Pandabuy Spreadsheet vs Forum Hunting: Which Is More Efficient',
    excerpt: 'A detailed comparison between using an organized pandabuy spreadsheet directory versus digging through scattered forum threads.',
    image: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20organized%20folders%20and%20notes%20on%20one%20side%20versus%20a%20messy%20scattered%20paper%20pile%20on%20the%20other%2C%20warm%20clean%20studio%20lighting%2C%20conceptual%20editorial%20photography%2C%20neutral%20cream%20background%2C%20contrast%20between%20order%20and%20chaos%20aesthetic%2C%20no%20text%20or%20branding&width=600&height=400&seq=seo-card-07-v2&orientation=landscape',
  },
  {
    id: 'article-8',
    title: 'The Ultimate Pandabuy Spreadsheet Checklist for Smart Shoppers',
    excerpt: 'A comprehensive checklist covering what to look for in every pandabuy spreadsheet link before making a purchase decision.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20a%20checklist%20notebook%20with%20a%20pen%20and%20a%20pair%20of%20stylish%20sunglasses%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20studio%20lighting%2C%20organized%20editorial%20lifestyle%20composition%2C%20neutral%20soothing%20tones%2C%20sophisticated%20clean%20aesthetic%2C%20no%20branding&width=600&height=400&seq=seo-card-08-v2&orientation=landscape',
  },
  {
    id: 'article-9',
    title: '2026 Pandabuy Spreadsheet Trends: What Shoppers Are Buying Now',
    excerpt: 'The latest trends emerging in the pandabuy spreadsheet community — from premium sneakers to designer-inspired accessories.',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20composition%20of%20trending%20fashion%20items%20including%20a%20structured%20bag%20sneakers%20and%20a%20watch%20arranged%20in%20a%20modern%20editorial%20layout%20on%20a%20cream%20surface%2C%20warm%20natural%20studio%20lighting%2C%20forward%20thinking%20contemporary%20aesthetic%2C%20rich%20earth%20tones%2C%20no%20branding%20visible&width=600&height=400&seq=seo-card-09-v2&orientation=landscape',
  },
];

export default function ArticleCards() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-white border border-background-200 rounded-full text-xs font-medium text-foreground-600 mb-4">
            Guides &amp; Insights
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Pandabuy Sheet
            <br />
            Guides &amp; Tips
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-md">
            Expert guides to help you get the most out of your pandabuy spreadsheet shopping experience.
          </p>
        </div>

        {/* Article Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/shopping-guide#${article.id}`}
              className="group flex flex-col bg-white border border-background-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Article Image */}
              <div className="relative w-full aspect-[3/2] bg-background-100 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              {/* Article Content */}
              <div className="p-5 md:p-6 flex flex-col gap-2 flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-500 mt-auto pt-2 whitespace-nowrap">
                  Read Guide <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}